import { combineReducers } from 'redux';
import pakReducer from "./pak/reducers";
import productsReducer from './product/productList/reducers';
import productData from './product/productOverview/reducers';
import uiReducer from './ui/reducers';
import pageShellReducer from './pageShell/reducers';
import menuReducer from './menu/reducers';
import sectionReducer from './section/reducers';
import languageReducer from './language/reducers';
import pageDataReducer from './pageData/reducers';
import searchParamsReducer from './searchParams/reducers';
import notificationReducer from './notification/reducers';
import labelUserMessageReducer from './labelUserMessage/reducers';
import sessionReducer from './sessionData/reducers';
import storesMapReducer from './storesMap/reducers';
import availabilityProductReducer from './availabilityProduct/reducers';
import captchaReducer from './captcha/reducers';
import orderReducer from './order/basic/reducers';
import manhattanOrderReducer from "./order/manhattan/transition/reducers";
import manhattanReducer from "./manhattan/reducers";
import transactionReducer from './transaction/reducers';
import orderSendToEmailStatusReducer from "./order/save-order-to-email/reducers";
import campaignReducer from "./campaign/campaignReducers";
import compareProductReducer from "./compareDevices/reducers";
import wishListReducer from "./wishList/reducers";
import recentlyViewedProductsReducer from "./product/productOverview/recentlyViewedProducts/reducers";
import voucherReducer, { greenVoucherReducer } from "./order/voucher/reducers";
import smsVerificationReducer from "./order/verification-sms/reducers";
import productInsuranceReducer from "./product/insurance/reducers";
import preBasketProductsReducer from "./preBasket/reducers";
import manhattanContractsReducer from "./contract/manhattan/reducers";
import SSOTestReducer from "./auth/reducers";
import cookieReducer from "./cookie/reducer";
import filtersListReducer from './filters/reducers';
import productSuggestionsReducer from './product/suggestions/reducers';
import debugReducer from "./debug/reducers";

const rootReducers = combineReducers({
  ui: uiReducer,
  products: productsReducer,
  productData: productData,
  pageShell: pageShellReducer,
  menuState: menuReducer,
  section: sectionReducer,
  language: languageReducer,
  pageData: pageDataReducer,
  searchParams: searchParamsReducer,
  notifications: notificationReducer,
  userMessage: labelUserMessageReducer,
  session: sessionReducer,
  storesMap: storesMapReducer,
  availabilityProduct: availabilityProductReducer,
  captcha: captchaReducer,
  order: orderReducer,
  manhattanOrder: manhattanOrderReducer,
  manhattan: manhattanReducer,
  manhattanTransaction: transactionReducer,
  campaign: campaignReducer,
  pakData: pakReducer,
  filtersList: filtersListReducer,
  compareProduct: compareProductReducer,
  contracts: manhattanContractsReducer,
  orderSendToEmailStatus: orderSendToEmailStatusReducer,
  wishList: wishListReducer,
  recentlyViewedProducts: recentlyViewedProductsReducer,
  voucher: voucherReducer,
  greenVoucher: greenVoucherReducer,
  smsVerification: smsVerificationReducer,
  productInsurances: productInsuranceReducer,
  productSuggestions: productSuggestionsReducer,
  preBasket: preBasketProductsReducer,
  SSOTest: SSOTestReducer,
  cookie: cookieReducer,
  debug: debugReducer
});

export type AppState = ReturnType<typeof rootReducers>;

export default rootReducers;
